import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TaskMemberInvitesKeyType {
  list: LocalesKey;
  plural: LocalesKey;
  accept: LocalesKey;
  acceptAll: LocalesKey;
  acceptSelected: LocalesKey;
  checkInAll: LocalesKey;
  checkInAllWithoutFollowers: LocalesKey;
  decline: LocalesKey;
  declineAll: LocalesKey;
  declineSelected: LocalesKey;
  search: LocalesKey;
  tasksInvitations: LocalesKey;
  areTouSureYouWantToAcceptAllTaskInvitationsThisActionCannotBeUndone: LocalesKey;
  areTouSureYouWantToDeclineAllTaskInvitationsThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToDeclineTaskInvitationThisActionCannotBeUndone: LocalesKey;
  areYouSureYouWantToDeleteTaskInvitationThisActionCannotBeUndone: LocalesKey;
  invited: LocalesKey;
  invitedBy: LocalesKey;
  invitedDate: LocalesKey;
  removeInvitation: LocalesKey;
}

export const taskMemberInvitesKeys = keyPathMirror<
  TaskMemberInvitesKeyType,
  string
>(
  {
    list: null,
    plural: null,
    accept: null,
    acceptAll: null,
    acceptSelected: null,
    checkInAll: null,
    checkInAllWithoutFollowers: null,
    decline: null,
    declineAll: null,
    declineSelected: null,
    search: null,
    tasksInvitations: null,
    areTouSureYouWantToAcceptAllTaskInvitationsThisActionCannotBeUndone: null,
    areYouSureYouWantToDeclineTaskInvitationThisActionCannotBeUndone: null,
    areTouSureYouWantToDeclineAllTaskInvitationsThisActionCannotBeUndone: null,
    areYouSureYouWantToDeleteTaskInvitationThisActionCannotBeUndone: null,
    invited: null,
    invitedBy: null,
    invitedDate: null,
    removeInvitation: null
  },
  'models.taskMemberInvites.'
);
